export default __webpack_public_path__ + "static/media/xpel_ultimate_plus.22dd97b3.webp";